.configurationTabpanel {
	max-height: 100%;
	margin-top: 0.3125rem;
	display: flex;
	flex-direction: column;
	gap: 0.625rem;
	width: 100%;
	padding: 0 0.5rem;
	overflow-y: auto;
	scrollbar-gutter: stable;
}
